module.exports = __webpack_public_path__ + "img/res-5.a1e53ca3.png";